import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
//      token: '',
    },
    mutations: {
    	//token
//      [types.TOKEN]: (state, data) => {
////      	console.log("token====",data)
////          localStorage.token = data;
////          state.token = data;
//      }
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js